module.exports = {"140931100":"东关镇","140931101":"义门镇","140931102":"桥头镇","140931103":"杨家湾镇","140931104":"孙家沟镇","140931200":"腰庄乡","140931201":"韩家川乡","140931202":"林遮峪乡","140931203":"冯家川乡","140931204":"土崖塔乡","140931208":"南河沟乡","140931400":"保德县居民事务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140931.json
// module id = 445
// module chunks = 0